import Api from "./Api";
import axios from "axios";
import Session from "@/classes/Session";
import { apiUrl } from "@/config/config";
import store from "@/store";

class SegmentsApi extends Api {
  constructor(version = "v2") {
    super(version);
    let jwt = Session.getJwtCookie();

    this.http = axios.create({
      baseURL: apiUrl + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      Session.logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }
    this.page_length = 25;
  }
  async getSegments(params) {
    if (params) {
      params = {
        search: params["search"] ? params["search"] : "",
        per_page: params["per_page"] ? params["per_page"] : 25,
        page: params["page"] ? params["page"] : 1,
        sort_by: params["sort_by"] ? params["sort_by"] : "id",
        sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
      };
    } else {
      params = {};
    }

    let response = await this.http.get("segments", {
      params: params
    });

    return response;
  }
  async getSegment(id) {
    let response = await this.http.get(`segments/${id}`)
    return response.data.resource
  }
  async updateSegment(id, params) {
    let response = await this.http.put(`segments/${id}`, params);

    if (response.status == 200) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.segments.actions.success",
        type: "success"
      });
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.segments.actions.error",
        type: "error"
      });
    }

    return response.data.resource;
  }
  async deleteSegment(id) {
    let response = await this.http.delete("segments" + "/" + id);
    return response.data.resource;
  }
  async createSegment(params) {  
    let response = await this.http.post("segments", params)
    return response.data.resource
  }
}

export default SegmentsApi;



// WEBPACK FOOTER //
// ./src/api/Segments.js